import React from 'react'
import Announcement from './Announcement'
import QA from './QA'
import FAQ from './FAQ'
import Review from './Review'

function Customer({ activeTab }) {
    if (activeTab === 1) {
        return <Announcement />
    }
    else if (activeTab === 2) {
        return <FAQ />
    }
    else if (activeTab === 3) {
        return <Review />
    }
    else if (activeTab === 4) {
        return <QA />
    }
}

export default Customer